import { useTranslation } from "@next-platform/client-common-core";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { ChangeEvent } from "react";
import { useCallback } from "react";

import Trans from "@/components/Trans/Trans";

import type { RulebookAttachOwnerKind } from "./useRulebookAttachTargets";

export type RulebookAttachControlsProps = {
  ownerKind: RulebookAttachOwnerKind;
  search: string;
  setSearch: (value: string) => void;
  isAlreadyAttached: boolean;
  selectedBlockedStatus: string;
};

const RulebookAttachControls = ({ ownerKind, search, setSearch, isAlreadyAttached, selectedBlockedStatus }: RulebookAttachControlsProps) => {
  const { t } = useTranslation();
  const handleSearchChange = useCallback((event: ChangeEvent<HTMLInputElement>) => setSearch(event.target.value), [setSearch]);
  const searchLabel = ownerKind === "characters" ? t("rulebook:attach.searchCharacters") : t("rulebook:attach.searchPersonas");

  return (
    <div className="flex flex-col gap-md pb-md" data-testid="RulebookAttachControls">
      {isAlreadyAttached ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-yellow-10">
          <Trans i18nKey="rulebook:attach.alreadyAttached" />
        </Text>
      ) : null}
      {selectedBlockedStatus === "underReview" ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-red-10">
          <Trans i18nKey="rulebook:attach.blocked.underReview" />
        </Text>
      ) : null}
      {selectedBlockedStatus === "actionRequired" ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-red-10">
          <Trans i18nKey="rulebook:attach.blocked.actionRequired" />
        </Text>
      ) : null}
      <input
        type="search"
        value={search}
        onChange={handleSearchChange}
        placeholder={searchLabel}
        aria-label={searchLabel}
        className="h-10 w-full rounded-md border border-gray-5 bg-transparent px-sm text-sm text-gray-12"
        data-testid={ownerKind === "characters" ? "RulebookAttachTargetModal-CharacterSearch" : "RulebookAttachTargetModal-PersonaSearch"}
      />
    </div>
  );
};

export default RulebookAttachControls;
